import { assetLoaderInstance } from "./assetLoaderInstance";

let loaded: Promise<WASMState> | undefined = undefined;

export function loadWasm() {
  if (!loaded) {
    loaded = (async () => {
      const assetLoader = await assetLoaderInstance();

      return await assetLoader.fetchWasm();
    })();
  }

  return loaded;
}

export interface WASMState {
  // eslint-disable-next-line @typescript-eslint/consistent-type-imports
  wasm?: typeof import("wasm");
  memory?: WebAssembly.Memory;
}
